import {
  CRUD_GET_LIST_SUCCESS,
  CRUD_DELETE_SUCCESS,
  CRUD_GET_ONE_SUCCESS,
  CRUD_CREATE_SUCCESS,
  CRUD_UPDATE_SUCCESS,
} from 'actions/dataActions';
import {CLEAR_CURD_RESOURCE_DATA} from "actions";

export default resource => (previousState = [], { type, payload, requestPayload, meta }) => {
  if (!meta || meta.resource !== resource) {
    return previousState;
  }
  switch (type) {
    case CLEAR_CURD_RESOURCE_DATA:
      return [];
    case CRUD_GET_LIST_SUCCESS:
      return payload.data.map(record => record.id);
    case CRUD_GET_ONE_SUCCESS:
    case CRUD_CREATE_SUCCESS:
    case CRUD_UPDATE_SUCCESS:
      return [payload.data.id];
    case CRUD_DELETE_SUCCESS: {
      const index = previousState.findIndex(el => el === requestPayload.id); // eslint-disable-line eqeqeq
      if (index === -1) {
        return previousState;
      }
      return [...previousState.slice(0, index), ...previousState.slice(index + 1)];
    }
    default:
      return previousState;
  }
};

export const getIds = (state) => state;



// WEBPACK FOOTER //
// ./src/reducers/resource/list/ids.js